import React, {useEffect, useRef, useState} from 'react';
import './viewer.css';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {useSetRecoilState} from 'recoil';
import {croppedImageAtom} from '../../../store';

function Viewer({
                    src, fileSuffix, uploadType, cropMode, style: myStyle,
                }) {
    const cropperRef = React.useRef(null);
    const [cropExtend, setCropExtend] = useState(false);
    const setObjectFileMap = useSetRecoilState(croppedImageAtom);
    const [preprocessedImage, setPreprocessedImage] = useState(null);

    const canvasToFile = (canvas, fileName) => new Promise((resolve) => {
        canvas.toBlob(
            (blob) => {
                const file = new File([blob], fileName, {type: 'image/png'});
                resolve(file);
            },
            'image/png',
            1,
        );
    });

    const onCrop = async () => {
        if (cropperRef.current) {
            const canvas = cropperRef.current.cropper.getCroppedCanvas({
                width: 500,
                height: 500,
                fillColor: '#fff',
            });
            if(canvas) {
                const file = await canvasToFile(canvas, 'croppedImage.png');
                setObjectFileMap(new Map([['image', file]]));
            }
        }
    };

    const getOriginalImage = (image) => {
        const canvas = document.createElement('canvas');
        const {width} = image;
        const {height} = image;
        const context = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        context.fillRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        return canvas.toDataURL();
    };

    useEffect(() => {
        if (cropperRef.current && uploadType === 'image') {
            const cropperInstance = cropperRef.current.cropper;
            cropperInstance.setAspectRatio(cropExtend ? 0 : 1);
            cropperInstance.crop();
            onCrop();
        }
    }, [cropExtend]);

    useEffect(() => {
        if (uploadType === 'image' && src) {
            const image = new Image();
            image.crossOrigin = "anonymous";
            image.src = src;
            setCropExtend(cropMode);
            if (cropMode === true) {
                image.onload = () => {
                    // const preprocessedImg = getPreprocessedImage(image);
                    // setPreprocessedImage(preprocessedImg);
                    const originalImg = getOriginalImage(image);
                    setPreprocessedImage(originalImg);
                };
            } else {
                image.onload = () => {
                    const originalImg = getOriginalImage(image);
                    setPreprocessedImage(originalImg);
                };
            }
            setTimeout(() => onCrop(), 500);
        }
    }, [src, uploadType, cropMode]);

    if (!src) {
        return null;
    }

    return (
        <div
            style={myStyle}
        >
            {uploadType === 'image' && (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '0.5rem',
                        left: '0rem',
                        top: '0rem',
                        maxWidth: '100%',
                    }}
                >
                    <Cropper
                        ref={cropperRef}
                        src={preprocessedImage}
                        style={{width: '100%', height: '100%'}}
                        aspectRatio={cropExtend ? 0 : 1}
                        viewMode={1}
                        preview=".img-preview"
                        minCropBoxHeight={50}
                        minCropBoxWidth={50}
                        autoCropArea={1}
                        background
                        guides
                        checkOrientation={false}
                        highlight={false}
                        cropBoxMovable
                        cropBoxResizable
                        cropend={onCrop}
                    />
                </div>
            )}
        </div>
    );
}

export default Viewer;
